import { UseQueryResult, useQuery } from "@tanstack/react-query";
import { axiosProperty, throwResponse } from "config/axios";
import { IDashboardName, IDashboardParams } from "../../interface";

export const useGetPropertyDashboardAppliancesCount = (
  params?: IDashboardParams
): UseQueryResult<IDashboardName[], Error> => {
  return useQuery(
    ["dashboard-property-appliances", "count-used", params],
    async () => {
      const res = await axiosProperty.get("/dashboard/appliances/count-used", {
        params,
      });
      if (res.status === 200) {
        return res.data.data;
      }
      throwResponse(res);
    },
    {
      keepPreviousData: true,
    }
  );
};

export const useGetPropertyDashboardAppliancesCountMost = (
  params?: IDashboardParams
): UseQueryResult<IDashboardName[], Error> => {
  return useQuery(
    ["dashboard-property-appliances", "count-used-most", params],
    async () => {
      const res = await axiosProperty.get("/dashboard/appliances/count-used", {
        params,
      });
      if (res.status === 200) {
        return res.data.data;
      }
      throwResponse(res);
    },
    {
      keepPreviousData: true,
    }
  );
};
